import React from "react";

import Joi from "joi-browser";
import Form from "../common/Form";

import db from "../../services/query";
import lbl from "../../data/Labels.json";

import { PopUpContext } from "../../contexts/popUpContext";

class TeacherContractForm extends Form {
  static contextType = PopUpContext;

  state = {
    drp: {
      entry_year: [],
    },
    data: {
      teacher: "",
      salary_per_hour: "",
      entry_year: "",
      second_job: 0,
    },
    errors: {},
  };

  componentDidMount = async () => {
    const { drp, data } = this.state;
    const {
      popUp: { cache, edit },
    } = this.context;

    data.teacher = cache

    if (edit) {
      data.teacher = edit.teacher;
      data.salary_per_hour = edit.salary_per_hour;
      data.entry_year = edit.entry_year_id;
      data.second_job = edit.second_job;
    }

    await db
        .getAll(`dropdowns/entryYears`)
        .then(({ data: { data } }) => (drp["entry_year"] = data));

    this.setState({ drp, data });
  };

  schema = {
    teacher: Joi.number(),
    salary_per_hour: Joi.number(),
    entry_year: Joi.number(),
    second_job: Joi.number()
  };

  doSubmit = async (e) => {
    const { togglePopUp, popUp } = this.context;

    console.log(popUp)
    let __controls = this.cleanObject({
      teacher: popUp?.cache ? popUp?.cache : popUp?.edit?.teacher,
      ...this.state.data,
    });

    try {
      if (popUp?.edit) {
        await db
            .edit(`teachers/contracts/${popUp?.edit?.salary_id}`, __controls)
            .then(() => {
              togglePopUp({ form: "toast" });
            })
            .catch((err) => {
              togglePopUp({
                form: "toast",
                message: err.toString(),
                type: "warning",
              });
            });
      } else {
        await db
            .save("teachers/contracts", __controls)
            .then(() => {
              togglePopUp({ form: "toast" });
            })
            .catch((err) => {
              togglePopUp({
                form: "toast",
                message: err.toString(),
                type: "warning",
              });
            });
      }
      if (popUp.callback) popUp.callback();
    } catch ({ response }) {
      if (response && response.status === 400) {
        const errors = { ...this.state.error };

        this.setState({ errors });
      }
    }
  };

  render() {
    const { data, drp } = this.state;
    const { popUp } = this.context;

    return (
      <div className="form-container">
        <form className="form crud" onSubmit={this.handleSubmit}>
          <div className="head">
            <p>{popUp?.edit ? lbl.EditContract : lbl.AddContract}</p>
          </div>
          <div className="form-inputs">
            {this.renderInput("salary_per_hour", "معاش فی ساعت", "number")}
            {this.renderSelect("entry_year", "سال تعلیمی", drp["entry_year"])}
            {this.renderCheckBox("second_job", "", "وظیفه دوم")}
          </div>
          <div className="form-buttons">
            {this.renderButton(popUp?.edit ? lbl.Edit : lbl.Save)}
          </div>
        </form>
      </div>
    );
  }
}

export default TeacherContractForm;
